import { ErrorHandler, Injectable } from '@angular/core';
import { MonitoringService } from './monitoring.service';
import { environment } from '../../../environments/environment';
import { AppConsts } from '../app-consts';

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerService implements ErrorHandler {
    private readonly isEnabledGrafana = false;

    constructor(private readonly _monitoringService: MonitoringService) {
        this.isEnabledGrafana =  environment[AppConsts.GrafanaConfigurationName].isEnabled;
    }

    handleError(error: Error): void {
        if (this.isEnabledGrafana) {
            this._monitoringService.logException(error);
        } else {
            console.error(error);
        }
    }
}